import { render } from "./StockBid.vue?vue&type=template&id=0d1c8b95&scoped=true&ts=true"
import script from "./StockBid.vue?vue&type=script&lang=ts"
export * from "./StockBid.vue?vue&type=script&lang=ts"

import "./StockBid.vue?vue&type=style&index=0&id=0d1c8b95&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1c8b95"]])

export default __exports__